import { Component } from '@angular/core';
import { BuildingBlock, BuildingBlockControlBaseComponent } from '../building-block.types';
/** this component helps to retrive personal information using driver license */
@BuildingBlock('info-retrieval-by-driver-license')
@Component({
  selector: 'ecp-autofill-info-driver-license',
  styleUrls: ['./autofill-info-driver-license.component.scss'],
  templateUrl: './autofill-info-driver-license.component.html'
})
export class AutofillInformationDriverLicenseComponent extends BuildingBlockControlBaseComponent {
  /** Front Side flags object */
  public uploadFront = {
    hasError: false,
    uploading: false,
    url: '',
    value: ''
  };
  /** Back Side flags object */
  public uploadBack = {
    hasError: false,
    uploading: false,
    url: '',
    value: ''
  };

  /** flag to Display general error message */
  public uploadError = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public ImageUpload(event: any, side: string): void {
    if (event.target.files && event.target.files[0] && side) {
      this.uploadFront.uploading = side === 'front';
      this.uploadBack.uploading = side === 'back';
      const file: File = event.target.files[0];
      if (this.validateFormat(file)) {
        // validate the file format
        const reader = new FileReader();
        reader.readAsDataURL(file); // read file as data url
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reader.onload = (onloadEvent: any) => {
          // called once readAsDataURL is completed
          if (onloadEvent.target.result && side === 'front') {
            this.upload(file, 'front');
            this.uploadFront.url = onloadEvent.target.result;
            this.uploadFront.uploading = false;
          } else if (onloadEvent.target.result && side === 'back') {
            this.upload(file, 'back');
            this.uploadBack.url = onloadEvent.target.result;
            this.uploadBack.uploading = false;
          } else {
            // TODO: General upload error
            this.uploadError = true;
          }
        };
      } else {
        this.fileFormatError(side);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public upload(file: File, side: string): void {
    // this method will upload img to api
    try {
      // code to upload
      this.continueNext();
    } catch (error) {
      // error handler
    }
  }

  /* To remove image */
  public removeImage(side): void {
    if (side && side.url) {
      side.url = undefined;
    }
    if (side && side.value) {
      side.value = undefined;
    }
    this.field.data.value = undefined;
  }

  /* To Enable contine button */
  public continueNext(): void {
    if (this.uploadFront.url && this.uploadBack.url) {
      // TODO- To make api call and get information from license
      this.field.data.value = true;
    } else {
      this.field.data.value = undefined;
    }
  }

  /* To check the file format */
  public validateFormat(file: File): boolean {
    const pattern = /image-*/;
    return !!file.type.match(pattern);
  }

  /* alert for choosing correct file format */
  public fileFormatError(side): void {
    // TODO
    if (side === 'front') {
      this.uploadFront.hasError = true;
      this.uploadFront.uploading = false;
    }
    if (side === 'back') {
      this.uploadBack.hasError = true;
      this.uploadBack.uploading = false;
    }
  }
}
